var _defs, _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1137({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3.05,
    y: 3.05,
    width: 9.9,
    height: 9.9,
    transform: "translate(8 -3.31) rotate(45)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 8,
    x2: 1,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1137);
export default __webpack_public_path__ + "static/media/Symbolpack_1_137.aa340df0baa919f001d8e5a47d2f751d.svg";
export { ForwardRef as ReactComponent };